import { convertTimezone } from "@/plugins/convertTimezone";
import i18n from '@/plugins/i18n';

function isValidDate(date) {
    return new Date(date) instanceof Date && !isNaN(new Date(date));
}

export default [
    {
      name: 'ch',
      title: i18n.t('_ModalDeletion.Channel'),
      titleClass: 'nowrap',
      width: "50px",
    },
    {
      name: 'name',
      title: i18n.t('_ModalDeletion.Channel Name'),
      titleClass: 'nowrap',
    },
    {
      name: 'deletion_by',
      title: i18n.t('_ModalDeletion.Connect By'),
      titleClass: 'nowrap',
    },
    {
      id: "deletion_date",
      name: "deletion_date",
      title: i18n.t('_ModalDeletion.Deleted By'),
      titleClass: 'nowrap',
      dataClass: 'nowrap',
      formatter:(value) => {
        return convertTimezone.utcToLocal(value);
      }
    },    
];


// WEBPACK FOOTER //
// ./src/components/modals/assets/page_fields.js